import React, { Component } from 'react';
import Imagemodal from '../../../FeedContainer/FeedImage/Imagemodal';
import iconHelper from '../../../../helpers/iconHelper';
import "./UserGallery.css";



class Dedicategridlist extends Component {

    constructor(props) {
      super(props);
  
      this.state = {
        currentActiveImage : null
      };
      this.openDedicateLightBox = this.openDedicateLightBox.bind(this);
    }

    openDedicateLightBox(index){
        this.props.toggleLightbox(index)
    }
    
    
    render() {
    let dedicateList = this.props.media_details;
    return (
     
          
        <ul>
            {dedicateList.map((tile,index) => {  
                return(
                    <li key={index}>
                        <a className="portfolio_box" href={void(0)}  onClick={()=>this.openDedicateLightBox(index)} > 
                            {(tile.media_type == 'IMAGE') ? 
                              <img 
                              src={(tile.media_type == 'IMAGE') ? tile.media_link : tile.thumbnail} alt={tile.title} 
                              onError = {(e) => {
                                  e.target.src = iconHelper['BREAKIMAGE']
                                }}
                              />
                              :
                              <video controls className="carousal-video" controlsList="nodownload">
                                <source src={tile.media_link} type="video/mp4" />
                                Your browser does not support the video tag.
                              </video>
                            }
                            
                        </a>
                    </li>
                )
            })
            }
        </ul>
                   

         
       
        

        );
    }
  }
  
  export default Dedicategridlist;
